import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ADD_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction, addSubscriptionFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getBookingUsersSagaAction, getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { ADD_SUBSCRIPTION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/add_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerAddSubscription(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const currentUser = yield select(state => state.currentUser);
    const booking_users_form = yield select(state => state.booking_users_form);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('user', args.data.user);
        formData.append('times', args.data.workouts_count);
        formData.append('duration', args.data.duration);
        formData.append('constraint', args.data.constraint);
        formData.append('coach', args.data.coach);
        formData.append('type', args.data.type);
        formData.append('note', args.data.note);
        formData.append('activation', args.data.activation);
        formData.append('establishment', currentEstablishment);
        formData.append('activation_date', args.data.activation_date);
        formData.append('expire_date', args.data.expire_date);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);
        formData.append('addition_date', args.data.addition_date);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму добавления абонемента
            yield put(addSubscriptionFormAction(ADD_SUBSCRIPTION_FORM_INITIAL));

            // Если добавляли абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если добавляли абонемент через список записанных на групповое занятие пользователей
            else if (booking_users_form.open && booking_users_form.id) {
                // Обновляем список пользователей
                yield put(getBookingUsersSagaAction({ booking_id: booking_users_form.id }));
            }
            // Если добавляли абонемент на странице с абонементами
            else {
                // Получение списка абонементов
                yield put(getSubscriptionsSagaAction());
            }

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherAddSubscription() {
    yield takeLatest(ADD_SUBSCRIPTION_SAGA, workerAddSubscription);
}